"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withLoyaltyStore } from "@jti/loyalty/utils/withLoyaltyStore";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

import { loyaltyHeroDefaultValues } from "../LoyaltyHeroV2/LoyaltyHero.builder";

export const loyaltyHeroContainerInputs = [
  {
    name: "isContainerWidth",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "isViewportHeight",
    type: "boolean",
    defaultValue: true,
  },
  {
    name: "mobileMediaAtTop",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "autoplayEnabled",
    friendlyName: "Autoplay enabled",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "autoplayDelay",
    friendlyName: "Autoplay delay interval",
    type: "string",
    enum: ["3", "4", "5", "6", "7", "8", "9", "10"],
    defaultValue: "5",
  },
  {
    name: "breadcrumbsSpacing",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "childBlocks",
    type: "uiBlocks",
    onChange: (options: Map<string, unknown>) => {
      const items = options.get("childBlocks");
      if (!Array.isArray(items)) return;

      const loyaltyItems = items.filter((item) => item?.component?.name === "LoyaltyHero");

      const allChildrenAreHero = items.length === loyaltyItems.length;

      if (!allChildrenAreHero) {
        options.set("childBlocks", loyaltyItems.slice(0, 3));
        alert("Only Hero Container related components are allowed");
      }

      if (items.length > 3) {
        options.set("childBlocks", items.slice(0, 3));
        alert("Only 3 Hero components are allowed");
      }
    },
    defaultValue: [
      {
        "@type": "@builder.io/sdk:Element",
        component: {
          name: "LoyaltyHero",
          options: {
            data: loyaltyHeroDefaultValues,
          },
        },
      },
    ],
  },
] as const satisfies Inputs;

export const LoyaltyHeroBannerContainerComponent: RegisteredComponent = {
  name: "LoyaltyHeroBannerContainer",
  friendlyName: "Loyalty Hero Banner Container ",
  component: dynamic(async () =>
    withLoyaltyStore(
      withValidation(
        loyaltyHeroContainerInputs,
        (await import("./LoyaltyHeroBannerContainer")).HeroBannerContainer,
        "HeroBannerContainer"
      )
    )
  ),
  shouldReceiveBuilderProps: {
    builderBlock: true,
  },
  canHaveChildren: true,
  childRequirements: {
    message: "Only Loyalty Hero Container related components are allowed",
    query: {
      "component.name": {
        $in: ["LoyaltyHero"],
      },
    },
  },
  inputs: loyaltyHeroContainerInputs,
  requiresParent: {
    query: {
      "component.name": { $in: ["LoyaltyWrapper"] },
    },
    message: "'LoyaltyHeroBannerContainer' component can only be added inside a 'LoyaltyWrapper'",
  },
};
